import { gql } from "@apollo/client";

export const INSURANCE_EVENTS_CORRELATION_QUERY = gql`
  {
    insuranceEventsCorrelation @client {
      correlations
    }
  }
`;
